"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var state_1 = __importDefault(require("./state"));
var dragon_container_1 = __importDefault(require("../views/dragon-container"));
var navigation_button_1 = __importStar(require("../views/navigation-button"));
var title_container_1 = __importDefault(require("../views/title-container"));
var game_area_1 = require("../utilities/game-area");
var park_container_1 = __importDefault(require("../views/park-container"));
var calculator_1 = __importStar(require("../models/calculator"));
var i18next_1 = __importDefault(require("i18next"));
var profile_state_1 = __importDefault(require("./profile-state"));
var name_container_1 = __importDefault(require("../views/name-container"));
var inbox_state_1 = __importDefault(require("./inbox-state"));
var ParkState = /** @class */ (function (_super) {
    __extends(ParkState, _super);
    function ParkState(app, client, dragonContainer) {
        var _this = _super.call(this) || this;
        _this._app = app;
        _this._client = client;
        _this._dragonContainer = dragonContainer;
        return _this;
    }
    Object.defineProperty(ParkState.prototype, "parkContainer", {
        get: function () {
            if (!this._parkContainer) {
                this._parkContainer = new park_container_1.default(this._app.loader.resources);
                this._parkContainer.scale.set(0.5);
                this._parkContainer.position.set(game_area_1.GAME_WIDTH * 0.5, game_area_1.GAME_HEIGHT * 0.5);
                this._parkContainer.dragonSlot.interactive = true;
                this._parkContainer.dragonSlot.on("pointerdown", this.onSelf.bind(this));
                this._parkContainer.dragonCurrentSlot.interactive = true;
                this._parkContainer.dragonCurrentSlot.on("pointerdown", this.onCurrent.bind(this));
                this._parkContainer.dragonNextSlot.interactive = true;
                this._parkContainer.dragonNextSlot.on("pointerdown", this.onNext.bind(this));
                this._parkContainer.dragonPreviousSlot.interactive = true;
                this._parkContainer.dragonPreviousSlot.on("pointerdown", this.onPrevious.bind(this));
            }
            return this._parkContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParkState.prototype, "backButton", {
        get: function () {
            var _this = this;
            if (!this._backButton) {
                this._backButton = new navigation_button_1.default(this._app.loader.resources.ui.textures, navigation_button_1.NAVIGATION_BUTTON_TYPE.BACK, function () {
                    _this.stateMachine.pop();
                });
                this._backButton.position.set(game_area_1.GAME_SAFE_AREA.left + 12, game_area_1.GAME_SAFE_AREA.top + 12);
            }
            return this._backButton;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParkState.prototype, "titleContainer", {
        get: function () {
            if (!this._titleContainer) {
                this._titleContainer = new title_container_1.default(this._app.loader.resources.ui.textures);
                this._titleContainer.setText(i18next_1.default.t("park_title"));
                this._titleContainer.position.set((game_area_1.GAME_WIDTH - this._titleContainer.width) * 0.5, game_area_1.GAME_SAFE_AREA.top + 12);
            }
            return this._titleContainer;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParkState.prototype, "inboxButton", {
        get: function () {
            var _this = this;
            if (!this._inboxButton) {
                this._inboxButton = new navigation_button_1.default(this._app.loader.resources.ui.textures, navigation_button_1.NAVIGATION_BUTTON_TYPE.INBOX, function () {
                    _this.stateMachine.push(inbox_state_1.default);
                });
                this._inboxButton.position.set(game_area_1.GAME_SAFE_AREA.right - this._inboxButton.width - 12, game_area_1.GAME_SAFE_AREA.top + 12);
            }
            return this._inboxButton;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParkState.prototype, "otherDragonContainers", {
        get: function () {
            if (!this._otherDragonContainers) {
                this._otherDragonContainers = [];
                for (var i = 0; i < 3; i++) {
                    var dragonContainer = new dragon_container_1.default(this._app.loader.resources);
                    this._otherDragonContainers.push(dragonContainer);
                }
            }
            return this._otherDragonContainers;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ParkState.prototype, "dragonNameContainers", {
        get: function () {
            if (!this._dragonNameContainers) {
                this._dragonNameContainers = [];
                for (var i = 0; i < 4; i++) {
                    var nameContainer = new name_container_1.default(this._app.loader.resources.ui.textures);
                    nameContainer.maxGems = calculator_1.default.evolutions(calculator_1.MAX_STAGE);
                    this._dragonNameContainers.push(nameContainer);
                }
            }
            return this._dragonNameContainers;
        },
        enumerable: false,
        configurable: true
    });
    ParkState.prototype.didEnterFrom = function (previousState) {
        var e_1, _a;
        var _b, _c, _d, _e;
        _super.prototype.didEnterFrom.call(this, previousState);
        this._app.stage.addChild(this.parkContainer);
        try {
            for (var _f = __values(this.dragonNameContainers), _g = _f.next(); !_g.done; _g = _f.next()) {
                var nameContainer = _g.value;
                this._app.stage.addChild(nameContainer);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_g && !_g.done && (_a = _f.return)) _a.call(_f);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this._app.stage.addChild(this.backButton);
        this._app.stage.addChild(this.titleContainer);
        this._app.stage.addChild(this.inboxButton);
        this.inboxButton.visible = ((_b = this._client.inbox) === null || _b === void 0 ? void 0 : _b.reactions.length) > 0;
        this._dragonContainer.setIdleAnimation();
        this.parkContainer.dragonSlot.addChild(this._dragonContainer);
        this.parkContainer.dragonCurrentSlot.addChild(this.otherDragonContainers[0]);
        this.parkContainer.dragonNextSlot.addChild(this.otherDragonContainers[1]);
        this.parkContainer.dragonPreviousSlot.addChild(this.otherDragonContainers[2]);
        this._otherDragons = (_d = (_c = this._client.park) === null || _c === void 0 ? void 0 : _c.dragons) !== null && _d !== void 0 ? _d : [];
        this._currentIndex = 0;
        this.update(0);
        this.reconfigure();
        this._client.sendEvent("park_entered", {
            dragons: (_e = this._client.park) === null || _e === void 0 ? void 0 : _e.dragons
        });
    };
    ParkState.prototype.willExitTo = function (nextState) {
        var e_2, _a;
        _super.prototype.willExitTo.call(this, nextState);
        this._app.stage.removeChild(this.parkContainer);
        try {
            for (var _b = __values(this.dragonNameContainers), _c = _b.next(); !_c.done; _c = _b.next()) {
                var nameContainer = _c.value;
                this._app.stage.removeChild(nameContainer);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        this._app.stage.removeChild(this.backButton);
        this._app.stage.removeChild(this.titleContainer);
        this._app.stage.removeChild(this.inboxButton);
        this.parkContainer.dragonSlot.removeChild(this._dragonContainer);
        this.parkContainer.dragonCurrentSlot.removeChild(this.otherDragonContainers[0]);
        this.parkContainer.dragonNextSlot.removeChild(this.otherDragonContainers[1]);
        this.parkContainer.dragonPreviousSlot.removeChild(this.otherDragonContainers[2]);
    };
    ParkState.prototype.update = function (deltaTime) {
        this.parkContainer.spine.update(deltaTime / 1000);
    };
    ParkState.prototype.onSelf = function () {
        var _this = this;
        this.stateMachine.push(profile_state_1.default, function (state) {
            state.dragonContainer = _this._dragonContainer;
            state.dragon = _this._client.dragon;
        });
    };
    ParkState.prototype.onCurrent = function () {
        var _this = this;
        this.stateMachine.push(profile_state_1.default, function (state) {
            state.dragonContainer = _this._otherDragonContainers[_this._currentIndex];
            state.dragon = _this._otherDragons[_this._currentIndex];
        });
    };
    ParkState.prototype.onNext = function () {
        var _this = this;
        this.stateMachine.push(profile_state_1.default, function (state) {
            var index = _this.wrap(_this._currentIndex, 1);
            state.dragonContainer = _this._otherDragonContainers[index];
            state.dragon = _this._otherDragons[index];
        });
    };
    ParkState.prototype.onPrevious = function () {
        var _this = this;
        this.stateMachine.push(profile_state_1.default, function (state) {
            var index = _this.wrap(_this._currentIndex, -1);
            state.dragonContainer = _this._otherDragonContainers[index];
            state.dragon = _this._otherDragons[index];
        });
    };
    ParkState.prototype.reconfigure = function () {
        var length = this.otherDragonContainers.length;
        for (var i = 0; i < length; i++) {
            var index = this.wrap(this._currentIndex + i, length);
            var hasDragon = index < this._otherDragons.length;
            var dragonContainer = this.otherDragonContainers[i];
            dragonContainer.visible = hasDragon;
            if (!hasDragon) {
                continue;
            }
            var dragon = this._otherDragons[index];
            var now = new Date();
            var quitDay = calculator_1.default.day(dragon.quit.start, now);
            var hatched = calculator_1.default.hatched(dragon.status.stage);
            dragonContainer.setHatched(hatched);
            dragonContainer.configureAppearance(quitDay, dragon.appearance.body, dragon.appearance.eyes, dragon.appearance.head, dragon.appearance.scales, dragon.appearance.tail, dragon.appearance.wings, dragon.appearance.hat, dragon.appearance.collar, dragon.appearance.band, false, false);
            dragonContainer.setIdleAnimation();
            var nameContainer = this.dragonNameContainers[i];
            this.updateNameContainer(nameContainer, dragonContainer, dragon);
        }
        this.updateNameContainer(this.dragonNameContainers[3], this._dragonContainer, this._client.dragon);
    };
    ParkState.prototype.updateNameContainer = function (nameContainer, dragonContainer, dragon) {
        var dragonPosition = this._app.stage.toLocal(dragonContainer.position, dragonContainer);
        nameContainer.setTitle(dragon.status.name, false, calculator_1.default.evolutions(dragon.status.stage));
        nameContainer.position.set(dragonPosition.x - (nameContainer.width * 0.5), dragonPosition.y + 16);
    };
    ParkState.prototype.wrap = function (index, offset) {
        var length = this.otherDragonContainers.length;
        return (((index + offset) % length) + length) % length;
    };
    return ParkState;
}(state_1.default));
exports.default = ParkState;
